<mat-menu>
    <button *ngIf="templates == null" mat-menu-item disabled>
        {{ 'messages-card.loading-template' | translate }}
      </button>
    <button *ngIf="templates && templates.length === 0"
            mat-menu-item
            disabled>
            {{ 'messages-card.no-custom-template' | translate }}
    </button>
    <ng-container *ngFor="let template of templates">
        <button *ngIf="template.textTemplate"
              mat-menu-item
              (click)="useTemplate(template)">
              {{ template.name }}
        </button>
    </ng-container>
</mat-menu>